<template>
  <div>
    <BaseCommonPage>
      <div v-bind:is="component" v-bind="{ designId: designId }" />
    </BaseCommonPage>
  </div>
</template>

<script>
import DesignPaperSample from "./DesignPaperSample";
import BaseCommonPage from "./BaseCommonPage";
import Top from "./Top";
import designpaperList from "../assets/design_papers_and_categories.json";
export default {
  name: "BaseDesignPaperSamplePage",
  props: {
    designId: String,
  },
  data() {
    return {
      designpaperList: designpaperList,
    };
  },
  components: {
    DesignPaperSample,
    BaseCommonPage,
    Top,
  },
  computed: {
    component: function () {
      const item = this.designpaperList.designPapers.find(
        function (item) {
          return item.id == this.designId;
        }.bind(this)
      );
      if (item == undefined) {
        return Top;
      }
      return DesignPaperSample;
    },
  },
};
</script>
<style>
</style>
